const state = {
    machineCameraData: [],
}
const getters = {
    get_machineCameraData: state => {
        return state.machineCameraData
    }
}
const actions = {
    set_machineCameraData(context, array) {
        context.commit('SET_MACHINECAMERADATA', array);
    }
}
const mutations = {
    SET_MACHINECAMERADATA(state, array) {
        state.machineCameraData = array;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/machineCamera.js